
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UseAgentPurchaseProps, UseAgentPurchaseResult } from "./agent-purchase/types";
import { requireAuth } from "./agent-purchase/auth-utils";
import { handleDownloadFreeAgent } from "./agent-purchase/free-agent-handler";
import { handlePurchasePaidAgent } from "./agent-purchase/paid-agent-handler";
import { handleFavoriteToggle, handleShareLink } from "./agent-purchase/social-actions";

export const useAgentPurchase = ({
  agent,
  user,
  walletBalance,
  setWalletBalance,
  purchaseSuccess,
  setPurchaseSuccess
}: UseAgentPurchaseProps): UseAgentPurchaseResult => {
  const navigate = useNavigate();
  const [purchasing, setPurchasing] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);

  const handlePurchase = () => {
    if (agent.pricingModel === "free") {
      if (requireAuth(user, agent.id, navigate)) {
        handleDownloadFreeAgent({
          agent,
          user,
          setPurchasing,
          setError,
          setPurchaseSuccess,
          navigate
        });
      }
    } else {
      if (requireAuth(user, agent.id, navigate)) {
        handlePurchasePaidAgent({
          agent,
          user,
          walletBalance,
          setPurchasing,
          setIsCheckingStatus,
          setError,
          setPurchaseSuccess,
          setWalletBalance,
          navigate
        });
      }
    }
  };

  const handleFavorite = () => {
    if (requireAuth(user, agent.id, navigate)) {
      handleFavoriteToggle({
        agentId: agent.id,
        userId: user?.id,
        setIsFavorite
      });
    }
  };
  
  const handleShare = () => {
    handleShareLink({
      agentId: agent.id,
      agentName: agent.name
    });
  };

  return {
    purchasing,
    isFavorite,
    isCheckingStatus,
    error,
    handlePurchase,
    handleFavorite,
    handleShare
  };
};
